import ContactUsImage from "../../assets/image/ContactUs.svg"
import ContactUsLogo from "../../assets/image/Contact-Us-Logo.svg"
import CopyRightLogo from "../../assets/image/copyright.svg"

export default function ContactUs() {
    return (
        <div id="ContactUs" className="py-[80px] sm:px-3 flex items-center flex-col 850responsive:pl-20">
            <div className="flex flex-col-reverse items-center m-5 850responsive:flex-row">
                <img src={ContactUsImage} alt="ContactUs" className="w-[328.41px] h-[311.83px] xl:w-[577.59px] xl:h-[548.42px]" />
                <div className="flex flex-col justify-between items-center h-[60%]">
                    <img src={ContactUsLogo} alt="ContactUsLogo" className="h-[90px] w-[214px]" />
                    <div className="mb-5 w-full flex flex-col items-center">
                        <h4 className="text-[#ABACC2] w-[100px] h-[24px] font-Poppins font-semibold text-[14px] leading-[24px] ">Main Office:</h4>
                        <p className="w-[360px] h-[57px] font-bold text-center text-[18px] leading-[30px] text-[#100F10]">
                            Unit 301, 3th Floor, Al Raya Tower
                            Ghala Industrial Area
                            Muscat, Sultanate of Oman
                        </p>
                        <div className="mb-5 w-full flex flex-col items-center">
                            <div className="flex items-center justify-center">
                                <h4 className="text-[#ABACC2] w-[121px] h-[24px] font-Poppins font-semibold flex items-center text-[14px] leading-[24px] 850responsive:w-[121px]">Mobile:</h4>
                                <p className="w-[165px] h-[30px] font-bold text-[18px] leading-[30px] text-[#100F10]">+968 71784017</p>

                            </div>
                            <div className="flex items-center justify-center">
                                <h4 className="text-[#ABACC2] w-[121px] h-[24px] font-Poppins font-semibold flex items-center text-[14px] leading-[24px] 850responsive:w-[121px]">Office:</h4>
                                <p className="w-[165px] h-[30px] font-bold text-[18px] leading-[30px] text-[#100F10]">+968 24033965</p>
                            </div>
                        </div>
                    </div>
                    <div className="mb-5 w-full flex flex-col items-center">
                        <h4 className="text-[#ABACC2] w-[135px] h-[24px] font-Poppins font-semibold text-[14px] leading-[24px] ">Technical Office:</h4>
                        <p className="w-[360px] h-[57px] font-bold text-center text-[18px] leading-[30px] text-[#100F10]">
                            Flat 18, Al Assail Building, South Al Mawaleh
                            Muscat, Sultanate of Oman
                        </p>
                        <div className="flex items-center justify-center">
                            <h4 className="text-[#ABACC2] w-[121px] h-[24px] font-Poppins font-semibold flex items-center text-[14px] leading-[24px] 850responsive:w-[121px]">Office:</h4>
                            <p className="w-[165px] h-[30px] font-bold text-[18px] leading-[30px] text-[#100F10]">+968 24553594</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex p-5 ">
                <img src={CopyRightLogo} alt="CopyRightLogo" />
                <div className="font-Roboto font-semibold text-[12px] leading-[14px] text-[#CDCDCD] flex flex-col">
                    <span className="w-[86px] h-[14px] ">Copyright 2022</span>
                    <span className="w-[194px] h-[14px]">All right reserved by <a href="https://nafun.co/" target="_blank" className="text-[#100F10]"> Nafun </a> company.</span>
                </div>
            </div>
        </div>
    )
}